<template>
    <div id="slider-component">
        <div class="sc-header">{{ slides[slideIndex].header }}</div>
        <div class="sc-slider">
            <svg width="500" viewBox="-10 -35 110 110" class="outline">
                <path d="M5 50 a50 50 50 1 1 80 0" stroke="rgba(255,255,255, 0.2)" stroke-width="7"
                      stroke-linecap="round" fill-opacity="0"/>
            </svg>
            <div class="sc-s-move-container">
                <div v-for="(slide, index) in slides" :key="`slide-${index}`" class="sc-slide-image" :style="`right: ${sliderPosition}`"
                     :class="{ 'active' : index === slideIndex }">
                    <div class="sc-s-i-image-container">
                        <img :src="require ('@/assets/img/' + slide.image)">
                    </div>
                </div>
            </div>
            <div class="stripe"></div>
        </div>
        <div class="sc-text" v-html="slides[slideIndex].text">
            {{ slides[slideIndex].text }}
        </div>
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "Slider",
        data() {
            return {
                slideIndex: 0,
                slideHeader: '',
                slideText: '',
                slideTransition: false
            }
        },
        computed: {
            sliderPosition() {
                return (this.slideIndex * 475) + 'px;';
            }
        },
        props: ['slides', 'years', 'historyBool'],
        methods: {
            nextSlide() {
                this.slideIndex++;
            }
        },
        created() {
            EventBus.$on('next-slide', () => {
                this.nextSlide();
            });
            this.slideIndex = 0;
        },
        mounted() {
            this.slideIndex = 0;
            this.slideHeader = this.slides[0].header;
            this.slideText = this.slides[0].text;

        }
    }
</script>

<style lang="scss">
    #slider-component {
        width: 100%;
        position: relative;
        height: auto;
        display: flex;
        flex-direction: column;
        max-width: 100vw;
        z-index: 1;

        .sc-header {
            text-align: center;
            justify-content: center;
            align-items: center;
            font-size: 23px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #ffffff;
            height: 70px;

            @media only screen and (max-device-width: 768px) {
                min-height: 190px;
                width: 90%;
                margin: 0 auto;
                font-size: 46px;
            }
        }

        .sc-text {
            width: 474px;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            margin: 0 auto;
            height: 90px;
            @media only screen and (max-device-width: 768px) {
                width: 90%;
                min-height: 80px;
            }
        }

        .sc-slider {
            position: relative;
            padding: 0;
            display: flex;
            flex-wrap: nowrap;
            overflow: hidden;
            height: 510px;
            width: 100%;
            margin: 0 auto;

            .outline {
                position: absolute;
                top: 5px;
                left: 50%;
                transform: translateX(-50%);
            }

            .sc-s-move-container {
                display: flex;
                align-items: center;
                width: 375px;
                height: auto;
                margin: 0 auto;

                .sc-slide-image {
                    display: inline-flex;
                    transition: all 800ms;
                    justify-content: center;
                    align-items: center;
                    width: 375px;
                    height: 375px;
                    min-width: 375px;
                    min-height: 375px;
                    border-radius: 375px;
                    overflow: hidden;
                    opacity: 0.3;
                    position: relative;
                    margin-right: 100px;

                    .sc-s-i-image-container {
                        display: flex;
                        width: 154px;
                        height: 154px;
                        min-width: 154px;
                        min-height: 154px;
                        border-radius: 154px;
                        overflow: hidden;
                        transition: all 500ms ease-in;
                        background: white;

                        img {
                            height: 100%;
                            width: auto;

                            &[src*="bitmap"] {
                                width: 144px;
                                height: 163px;
                                margin: auto;
                            }
                        }
                    }

                    &.active {
                        overflow: hidden;
                        opacity: 1;

                        .sc-s-i-image-container {
                            width: 375px;
                            height: 375px;
                            min-width: 375px;
                            min-height: 375px;

                        }
                    }
                }
            }

            .stripe {
                width: 100vw;
                height: 1px;
                background: white;
                position: absolute;
                top: 50%;
                z-index: -5;
            }
        }

    }

</style>